import { localDateKey } from "./dates";

const QUOTA_KEY = "marianne_quota_v1";

export function getBrowserQuota() {
  const date = localDateKey();
  try {
    const saved = JSON.parse(localStorage.getItem(QUOTA_KEY) || "{}");
    return { date, count: saved.date === date && Number.isInteger(saved.count) && saved.count > 0 ? saved.count : 0 };
  } catch {
    return { date, count: 0 };
  }
}

export function incrementBrowserQuota() {
  const quota = getBrowserQuota();
  quota.count += 1;
  try { localStorage.setItem(QUOTA_KEY, JSON.stringify(quota)); } catch { /* Storage can be disabled. */ }
  return quota;
}
